export default __webpack_public_path__ + "static/media/cosmetic2.763a8c27.jpg";